import { Inject, Injectable } from '@angular/core';
import { apiUrlToken } from 'shared';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetLatestRegistrationsRequest } from '../models/get-latest-registrations-request';
import { EventRegistrations } from '../models/event-registrations';

@Injectable({
  providedIn: 'root'
})
export class SponsorRunEventService {

  constructor(private http: HttpClient, @Inject(apiUrlToken) private apiUrl: string) {
  }

  public getLatestEventRegistrations(getLatestRegistrationsRequest: GetLatestRegistrationsRequest): Observable<EventRegistrations> {
    return this.http.post<EventRegistrations>(`${this.apiUrl}/api/SponsorRunEvent/GetLatestEventRegistrations/`, getLatestRegistrationsRequest);
  }
}
